const calculateRatio = (height: number, width: number) => height / width;

export const calculateProportionalWidth = ({
  height,
  width,
  maxHeight,
}: {
  height: number;
  width: number;
  maxHeight: number;
}) => {
  const ratio = calculateRatio(height, width);
  return maxHeight / ratio;
};
